<template>
  <subscriber-table :add-resource-bottom="addResourceBottom"></subscriber-table>
</template>

<script>
import { mapState } from "vuex";
import SubscriberTable from "./SubscriberTable.vue";
import store from "../../store/stores";

export default {
  name: "Subscribers",
  components: {
    SubscriberTable,
  },
  store,
  props: {
    customerId: {
      type: Number,
      required: true,
    },
    addResourceBottom: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState(["testdrive"]),
  },
  mounted() {
    const $this = this;
    $('a[href="#tab_test_drives"]').on("shown.bs.tab", function callback() {
      $this.getSubscribers();
    });
  },
  created() {
    this.$store.commit("testdrive/SET_CUSTOMER_ID", this.customerId);
    this.$store.dispatch("testdrive/getSubscribers");
  },
  methods: {
    getSubscribers() {
      this.$store.dispatch("testdrive/getSubscribers");
    },
  },
};
</script>

<style scoped></style>
